import styled from 'styled-components'

export const Container = styled.div`
  margin: 0.5rem 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media screen and (min-width: 370px) {
    max-width: 32rem;
  }

  @media screen and (min-width: 992px) {
    display: none;
  }
`

export const Button = styled.a`
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.8rem;
  padding: 0.9rem;
  text-align: center;
  border-radius: 2.1rem;
  border: 2px solid;
  font-weight: 500;
  text-decoration: none;
  transition:
    color,
    background,
    fill,
    border 0.2s ease-in-out;

  color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
  }

  font-size: unset;
  line-height: unset;
`
